var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundPerfomancePage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B7D9B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1652_50558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 13.28V11C27 9.9 26.1 9 25 9H11C9.89 9 9 9.9 9 11V25C9 26.1 9.89 27 11 27H25C26.1 27 27 26.1 27 25V22.72C27.59 22.37 28 21.74 28 21V15C28 14.26 27.59 13.63 27 13.28ZM26 15V21H19V15H26ZM11 25V11H25V13H19C17.9 13 17 13.9 17 15V21C17 22.1 17.9 23 19 23H25V25H11Z",
    fill: "#0C4A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5C22.8284 19.5 23.5 18.8284 23.5 18C23.5 17.1716 22.8284 16.5 22 16.5C21.1716 16.5 20.5 17.1716 20.5 18C20.5 18.8284 21.1716 19.5 22 19.5Z",
    fill: "#0C4A0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1652_50558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundPerfomancePage1);
export default __webpack_public_path__ + "static/media/fundPerfomancePage1.b6f8017d5a3c4f45878b06414d9c2fe9.svg";
export { ForwardRef as ReactComponent };